import type { JSX } from 'react';

import { CircleCheck, CircleX, Clock, LoaderCircle, TriangleAlert } from 'lucide-react';

import { cn } from '@/lib/utils';

import type { AgentTestRunStatus } from '../../model/run';

const STATUS_CONFIG: Record<
  AgentTestRunStatus,
  { label: string; className: string; Icon: typeof CircleCheck; spin?: boolean }
> = {
  pending: { label: 'Pendiente', className: 'border border-border-subtle text-text-muted', Icon: Clock },
  running: { label: 'Corriendo', className: 'bg-brand-vivid/10 text-brand-vivid', Icon: LoaderCircle, spin: true },
  completed: { label: 'Completado', className: 'bg-success/15 text-success', Icon: CircleCheck },
  partial: { label: 'Parcial', className: 'bg-warning/15 text-warning', Icon: TriangleAlert },
  failed: { label: 'Fallido', className: 'bg-error/15 text-error', Icon: CircleX },
  aborted: { label: 'Abortado · presupuesto', className: 'bg-warning/15 text-warning', Icon: TriangleAlert },
};

interface RunStatusBadgeProps {
  status: AgentTestRunStatus;
  detail?: string;
}

const RunStatusBadge = ({ status, detail }: RunStatusBadgeProps): JSX.Element => {
  const config = STATUS_CONFIG[status];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[0.7rem] font-medium whitespace-nowrap',
        config.className
      )}
    >
      <config.Icon className={cn('size-3', config.spin && 'animate-spin')} aria-hidden />
      {config.label}
      {detail ? ` ${detail}` : ''}
    </span>
  );
};

export default RunStatusBadge;
